import { render } from "./EditRayonPage.vue?vue&type=template&id=35d05827&ts=true"
import script from "./EditRayonPage.vue?vue&type=script&lang=ts"
export * from "./EditRayonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__